function initFAQToggle() {
    const allFAQLinks = document.querySelectorAll('.component__faq__list--item__question');
    if (allFAQLinks.length !== 0) {
        for (const faqLink of allFAQLinks) {
            faqLink.addEventListener('click', function (event) {
                event.preventDefault();
                const parent = event.target.closest('.component__faq__list--item');
                if (parent.classList.contains('active')) {
                    parent.classList.remove('active');
                }
                else {
                    parent.classList.add('active');
                }
            })
        }
    }
}

initFAQToggle();